
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { SidebarProvider } from "@/components/ui/sidebar/sidebar-context";
import { 
  Sidebar as SidebarComponent, 
  SidebarContent, 
  SidebarFooter 
} from "@/components/ui/sidebar/sidebar";
import { SidebarComponentProps } from "./sidebar/types";
import { LogoutButton } from "./sidebar/LogoutButton";
import { AccessCodeVerificationDialog } from "./sidebar/AccessCodeVerificationDialog";
import { SidebarMenu } from "./sidebar/SidebarMenu";
import { useSidebarState } from "./sidebar/SidebarState";
import { useIsMobile } from "@/hooks/use-mobile";
import { useOwnerData } from "@/hooks/useOwnerData";

export const Sidebar = ({ userType = "admin", isInventoryActive = false }: SidebarComponentProps) => {
  const {
    authorizedFeatures,
    visibleMenuItems,
    accessCodes,
    selectedMenuItem,
    isDialogOpen,
    filteredLinks,
    setIsDialogOpen,
    setSelectedMenuItem,
    handleEyeClick,
    toggleMenuItemVisibility,
    shouldShowEyeIcon,
    isFeatureVisible,
  } = useSidebarState(userType);

  const isMobile = useIsMobile();
  const { data: ownerData } = useOwnerData();

  return (
    <SidebarProvider>
      <SidebarComponent className={`
        h-full
        w-64
        bg-white 
        shadow-lg
        transition-all
        duration-200
        ease-in-out
      `}>
        <div className="p-4 border-b">
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="/lovable-uploads/30e09b3a-7f5e-4ff7-9a02-7dcfcd6951b6.png" 
              alt="Logo" 
              className="h-8 w-8"
            />
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-primary">Sibystock</span>
              {ownerData?.company_name && (
                <span className="text-sm text-gray-600">{ownerData.company_name}</span>
              )}
            </div>
          </Link>
        </div>
        
        <SidebarContent>
          <SidebarMenu
            links={filteredLinks}
            userType={userType}
            isInventoryActive={isInventoryActive}
            visibleMenuItems={visibleMenuItems}
            authorizedFeatures={authorizedFeatures}
            onEyeClick={handleEyeClick}
            shouldShowEyeIcon={shouldShowEyeIcon}
            isFeatureVisible={isFeatureVisible}
            accessCodes={accessCodes}
          />
        </SidebarContent>
        
        <SidebarFooter className="border-t p-4">
          <LogoutButton isInventoryActive={isInventoryActive} />
        </SidebarFooter>
      </SidebarComponent>

      <AccessCodeVerificationDialog
        open={isDialogOpen}
        onOpenChange={() => {
          setIsDialogOpen(false);
          setSelectedMenuItem(null);
        }}
        onVerify={() => {
          if (selectedMenuItem) {
            toggleMenuItemVisibility(selectedMenuItem);
          }
        }}
        expectedCode={selectedMenuItem ? accessCodes[(filteredLinks.find(l => l.name === selectedMenuItem) as any).feature] : undefined}
      />
    </SidebarProvider>
  );
};

export { Sidebar as SidebarComponent };
